const features = [
  {
    icon: "ri-bookmark-line",
    title: "阅读书签",
    text: "翻页即自动生成书签，随时退出、随时回来，打开就是上次看到的那一页。",
    tone: "text-primary-600 bg-primary-100",
  },
  {
    icon: "ri-refresh-line",
    title: "跨设备同步",
    text: "手机、平板、电脑一个账号全打通，进度实时同步，换设备无缝衔接。",
    tone: "text-secondary-700 bg-secondary-100",
  },
  {
    icon: "ri-history-line",
    title: "历史记录",
    text: "自动记录阅读历史与时间轴，翻找看过的作品一目了然，不遗漏任何一部。",
    tone: "text-accent-800 bg-accent-100",
  },
  {
    icon: "ri-play-circle-line",
    title: "断点续读",
    text: "无论在哪个设备停下的，回到任意设备都能精确接续，接着上次的位置继续看。",
    tone: "text-primary-600 bg-primary-100",
  },
  {
    icon: "ri-heart-line",
    title: "收藏不丢",
    text: "书架与收藏与账号绑定并跨端同步，换设备不重收，喜欢的作品永远在。",
    tone: "text-accent-800 bg-accent-100",
  },
  {
    icon: "ri-footprint-line",
    title: "阅读足迹",
    text: "清晰记录你的阅读足迹与偏好，为你推荐更合口味的下一部好漫画。",
    tone: "text-secondary-700 bg-secondary-100",
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-800">
            <i className="ri-star-smile-line"></i>
            核心功能
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
            把"读漫画"这件小事，做到不用操心
          </h2>
          <p className="mt-4 text-foreground-700">
            尾巴漫画网围绕书签、同步与历史三个核心能力打磨体验，让你只管沉浸故事，剩下的交给它。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <article
              key={feature.title}
              className="group rounded-2xl border border-background-200 bg-background-50 p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <div
                className={`flex h-12 w-12 items-center justify-center rounded-xl text-xl ${feature.tone}`}
              >
                <i className={feature.icon}></i>
              </div>
              <h3 className="mt-4 font-heading text-xl text-foreground-950">{feature.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{feature.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}